export function gcalUrl({ title, start, end, description, location }) {
    if (!start) return null;
    const fmt = (d) => { try { return new Date(d).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); } catch { return null; } };
    const s = fmt(start);
    if (!s) return null;
    const e = end ? fmt(end) : fmt(new Date(start).getTime() + 2 * 3600 * 1000);
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: title || 'The Hyderabad Library event',
        dates: `${s}/${e}`,
        details: description || '',
        location: location || 'The Hyderabad Library, 2nd Floor, BBR Forum, Road No. 2 Banjara Hills, Hyderabad',
    });
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
